import React from 'react';
import { renderIcon } from '../../../../SprintDetail/FlowchartView/utils/renderIcon';
import { MissionIcon, ChevronDownIcon } from '../icons';
import { STATUS_COLORS } from '../constants';
import ViewMenu from './ViewMenu';

/**
 * MissionColumn - Right column showing mission search results
 */
const MissionColumn = ({
  missions,
  isLoading,
  searchQuery,
  openViewMenuId,
  viewMenuPosition,
  getViewsForCampaign,
  onMissionClick,
  onMissionViewSelect,
  onToggleViewMenu,
}) => {
  return (
    <div className="unified-search-popup__column">
      <div className="unified-search-popup__column-header">
        <MissionIcon size={12} />
        <span>Missions</span>
        <span className="unified-search-popup__count">
          {isLoading ? '...' : missions.length}
        </span>
      </div>
      <div className="unified-search-popup__list">
        {isLoading && !missions.length ? (
          <div className="unified-search-popup__empty">Searching...</div>
        ) : missions.length > 0 ? (
          missions.map(mission => (
            <MissionItem
              key={`${mission.campaignId}-${mission.id}`}
              mission={mission}
              isMenuOpen={openViewMenuId === `mission-${mission.id}`}
              viewMenuPosition={viewMenuPosition}
              views={getViewsForCampaign(mission.campaignId)}
              onClick={() => onMissionClick(mission)}
              onViewSelect={(view) => onMissionViewSelect(mission, view)}
              onToggleViewMenu={(e) => onToggleViewMenu(e, mission.id, 'mission')}
            />
          ))
        ) : (
          <div className="unified-search-popup__empty">
            {searchQuery ? 'No missions found' : 'Type to search missions'}
          </div>
        )}
      </div>
    </div>
  );
};

/**
 * MissionItem - Individual mission result item
 */
const MissionItem = ({
  mission,
  isMenuOpen,
  viewMenuPosition,
  views,
  onClick,
  onViewSelect,
  onToggleViewMenu,
}) => {
  const statusColor = STATUS_COLORS[mission.status] || STATUS_COLORS.pending;

  return (
    <div
      className="unified-search-popup__item unified-search-popup__item--mission"
      onClick={onClick}
      style={{ '--status-color': statusColor }}
    >
      <span className="unified-search-popup__mission-icon">
        {renderIcon(mission.icon, { 
          size: '20px',
          fallback: mission.nodeType === 'decision' ? '◇' : null
        }) || <MissionIcon size={20} />}
      </span>
      <div className="unified-search-popup__item-main">
        <span className="unified-search-popup__item-name">{mission.name || 'Untitled'}</span>
        <span className="unified-search-popup__item-path">from {mission.campaignPath}</span>
      </div>
      <div className="unified-search-popup__item-actions">
        <button 
          className={`unified-search-popup__view-dropdown-btn ${isMenuOpen ? 'unified-search-popup__view-dropdown-btn--open' : ''}`}
          onClick={onToggleViewMenu}
          title="Open in view..."
        >
          Open in…
          <ChevronDownIcon size={10} />
        </button>
      </div>
      {/* View Selection Menu */}
      {isMenuOpen && viewMenuPosition && (
        <ViewMenu
          views={views}
          position={viewMenuPosition}
          onSelectView={onViewSelect}
          onStopPropagation={(e) => e.stopPropagation()}
        />
      )}
    </div>
  );
};

export default MissionColumn;
